<!-- <mat-toolbar color="primary">
	<mat-toolbar-row>
		<span class="app-title">{{ app.title.getTitle() }} <span class="version">{{ app.version }}</span></span>
		<div class="push"></div>
		<button mat-mini-fab [matMenuTriggerFor]="userMenu"><mat-icon>{{ (auth ? 'icon_user' : 'icon_user_guest') | translate }}</mat-icon></button>
	</mat-toolbar-row>
</mat-toolbar>

<router-outlet></router-outlet>

<mat-menu #userMenu>
	<ng-container *ngIf="!!auth">
		<button mat-menu-item disabled *ngIf="!!auth">{{ auth?.email }}</button>
		<mat-divider></mat-divider>
	</ng-container>
	<ng-container >
		<button *ngIf="!auth" mat-menu-item (click)="app.showLogin()"><mat-icon>{{ 'icon_login' | translate }}</mat-icon>{{ 'Login' | translate }}</button>
	</ng-container>
	<button mat-menu-item *ngIf="app.languages.length > 1" [matMenuTriggerFor]="languageMenu"><mat-icon>{{ 'icon_language' | translate }}</mat-icon>{{ 'Language' | translate }}</button>
	<ng-container *ngIf="!!auth">
		<mat-divider></mat-divider>
		<button mat-menu-item *ngIf="!!auth" (click)="logout()"><mat-icon>{{ 'icon_logout' | translate }}</mat-icon>{{ 'Logout' | translate }}</button>
	</ng-container>
</mat-menu>

<mat-menu #languageMenu>
	<button mat-menu-item *ngFor="let l of app.languages" (click)="changeLanguage(l.id)" [disabled]="l.id === language">{{ l.label }}</button>
</mat-menu> -->

<!-- <h3>Tests - comment these out</h3>
<button (click)="testConfirm()">Test Confirm</button><br>
<button (click)="app.notify.success('a success!!', 'x')">Notify - Success</button><button (click)="app.notify.warn('a warn', 'x')">Notify - warn</button><button (click)="app.notify.inform('an inform (primary)', 'x')">Notify - inform</button><br> -->

<router-outlet>

	
</router-outlet>